// ProfileContext.tsx
import { createContext, createResource, useContext, JSX, createEffect, createSignal } from "solid-js";
import { isServer } from "solid-js/web";
import type { Resource } from "solid-js";
import { createAsync, revalidate, query } from "@solidjs/router";

import { updateDB } from "~/_server";
import { getProfile } from "~/_server/dynamoDB";
import { getProfileQuery, type AddressType } from "~/lib";
import { useRIASApp } from "./UserProvider";

type Profile = {
	name: string;
	email: string;
	firstName: string;
	lastName: string;
	address: AddressType,
};

type ProfileContextValue = {
	profile: Resource<Profile | undefined>;
	updateProfile: ( field: string, value: any ) => Promise<void>;
};

export const ProfileContext = createContext<ProfileContextValue>();

export const useProfile = (): ProfileContextValue => useContext( ProfileContext ) as ProfileContextValue;

/*
const getProfile =async ( profileId: number ) => {
							const r = await fetch(`/api/profile/`, {
				method: "POST",
				body: JSON.stringify({ profileId }),
			});

			const json = await r.json();
			console.log("getProfileQuery", json);
			return json.profile;
};*/

const localGetProfile = query( async ( userId: number ) => {

	if ( !userId || userId == 0 ) return {};

	try {
		console.log( 'getting profile', userId );

		sessionStorage.setItem( "getProfile", userId.toString() );
		return await getProfile( userId );
	} catch ( err ) {
		console.log( 'getting profile failed', err );
	}

	return {};
}, "localGetProfile" );

export const ProfileProvider = ( props: { children: JSX.Element } ) => {
	const app = useRIASApp();

	const [userId, setUserId] = createSignal( 0 );

	createEffect( () => {
		const id = app.sessionId();

		setUserId( id );
	} );

	const profile = createAsync( () => localGetProfile( userId() ), { deferStream: isServer } );


	const updateProfile = async ( field: string, value: any ) => {
		if ( !profile.latest?.pk ) return;

		// 1️⃣ Optimistically update UI immediately
		//mutateProfile( ( prev ) => ( {			...prev,			[field]: value		} ) );

		try {
			// 2️⃣ Perform the actual DynamoDB update
			await updateDB( profile.latest?.pk, profile.latest?.sk, { [field]: value } );

		} catch ( err ) {
			console.error( "Update failed:", err );

		} finally {
			// 4️⃣ Refresh or Roll back UI to server state if update failed
			revalidate( getProfileQuery.keyFor( userId() ) );
		}
	};


	return (
		<ProfileContext.Provider value={{ profile, updateProfile }}>
			{props.children}
		</ProfileContext.Provider>
	);
};
